import { Injectable } from '@angular/core';
import {
    CanActivate, CanLoad, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot, Route
} from '@angular/router';
import { AuthService } from './auth.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';


@Injectable()
export class AuthGuard implements CanActivate, CanLoad {

    constructor(private authService: AuthService, private router: Router) {}

    /**
     * Custom implementation for Angular Auth Guard which allows us to check if users can access a route.
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        let url: string = state.url;
        return this.isUserAllowedToViewRoute(url);
    }

    /**
     * Used at app start up to see if the user has access to the requested module.
     */
    canLoad(route: Route): Observable<boolean> | boolean {
        let url = `/${route.path}`;
        return this.isUserAllowedToViewRoute(url);
    }

    /**
     * Authenticate logged in users session token is valid - ensures local storage values not tampered with
     * @param url - Url user is attempting to view
     */
    private isUserAllowedToViewRoute(url: string): Observable<boolean> | boolean {

        // Store the attempted URL for redirecting
        this.authService.redirectUrl = url;

        // User not logged in
        if (!this.authService.isLoggedIn) {
            this.router.navigate(['/login']);
            return false;
        }

        // If it is not an admin URL - the user is now allowed to view the route
        if (!url.includes('admin')) {
          return true;
        }

        // Piping the result to a map allows us to cast the subscription to an Observable
        return this.authService.validateSessionToken().pipe(map(user => {

            if (user.role === 'TW_ADMIN' || user.role === 'CUSTOMER_ADMIN') {
                return true;
            } else {
                // TODO would be nicer to show an error message or page here, but OK for now
                this.router.navigate(['/login']);
                return false;
            }
        }), catchError(( e: any) =>  {
            // If an error occurs while validating the login it's possible that the user's token has become stale
            // or has been manipulated.  So force the user to logout and then login again
            this.authService.logout();
            this.router.navigate(['/login']);
            return of(false);
        }));
    }
}
